import LocationDialog from './LocationDialog';

export default LocationDialog;
